// modules
import { createSelector } from 'reselect'
import { get, sortBy } from 'lodash'

// constants
import {
  MAP_ACTIVITIES_CAMEL_CASE,
  MAP_ACTIVITIES_TO_CODES
} from 'src/constants'

const companyDashboard = (state) =>
  get(state, ['dashboard', 'companyDashboard'], {})

const companyDashboardData$ = createSelector(
  companyDashboard,
  ({ companyDashboardData = {} }) => companyDashboardData
)

const companyDashboardActivitiesData$ = createSelector(
  companyDashboard,
  ({ companyDashboardActivitiesData = {} }) => companyDashboardActivitiesData
)

export const companyDashboardAlerts$ = createSelector(
  companyDashboardData$,
  ({ alerts = {} }) => alerts
)

export const companyDashboardEnrollment$ = createSelector(
  companyDashboardData$,
  ({ enrollment = {} }) => enrollment
)

export const companyDashboardFollowUpCalls$ = createSelector(
  companyDashboardData$,
  ({ followUpCalls = 0 }) => followUpCalls
)

export const companyDashboardPatients$ = createSelector(
  companyDashboardData$,
  ({ patients = [] }) => patients
)

export const todayActivitiesCount$ = createSelector(
  companyDashboardActivitiesData$,
  ({ today = [] }) => today
)

export const byModuleActivitiesCount$ = createSelector(
  companyDashboardActivitiesData$,
  ({ byModule = [] }) => byModule
)

export const mappedByModuleActivitiesCount$ = createSelector(
  byModuleActivitiesCount$,
  (byModuleActivitiesCount = {}) =>
    sortBy(
      Object.keys(byModuleActivitiesCount).map((activityType) => ({
        ...byModuleActivitiesCount[activityType],
        activityType: MAP_ACTIVITIES_CAMEL_CASE.get(activityType),
        activityCode: MAP_ACTIVITIES_TO_CODES.get(activityType)
      })),
      'activityType'
    )
)

export const companyDashboardAlertsPriorityCount$ = createSelector(
  companyDashboard,
  ({ alertsPriorityCount = {} }) => alertsPriorityCount
)
